import { Injectable } from '@angular/core';
import { Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { TimeoutError } from "rxjs";
import { GlobalVariables } from '../variables/global';

@Injectable()
export class HttpService extends Http {
    static TIMEOUT_VALUE = 40000;

    constructor(
        backend: XHRBackend,
        options: RequestOptions) {
        super(backend, options);
    }

    request(url: Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, options).timeout(HttpService.TIMEOUT_VALUE).catch(this.catchError(this));
    }

    private catchError(self: HttpService) {
        return (error: Response) => {
            if (error.status === 0) {
                return Observable.throw(new Response(
                    new ResponseOptions({
                        body: { description: 'server' },
                        status: 409
                    })));
            } else if (error.status === 408 || error instanceof TimeoutError) {
                return Observable.throw(new Response(
                    new ResponseOptions({
                        body: { description: 'timeout' },
                        status: 409
                    })));
            } else if (error.status === 401) {
                GlobalVariables.clearStorage();

                let _error = error.json().message === 'Unauthorized' ? 'The session has expired. Please login again.' : error.json().error_description;
                return Observable.throw(new Response(
                    new ResponseOptions({
                        body: {
                            stack: {
                                code: 401
                            },
                            description: _error,
                            redirect:'/',
                        }
                    })));
            } else return Observable.throw(error);
        };
    }
}



// WEBPACK FOOTER //
// ./src/providers/http-service.ts